


































import Vue from 'vue'

declare var $: any

export default Vue.extend({
    props: {
      values: {
          type: Array
      }
    },
    beforeDestroy() {
      $(this.$refs.modal).off('hidden.bs.modal')
    },
    watch: {
      values(values: any) {
          if (values && values.length > 0) $(this.$refs.modal).modal('show');
          else $(this.$refs.modal).modal('hide');
      }
    },
    updated() {
      if (this.values && this.values.length > 0) {
          $(this.$refs.modal).modal('show')
      }
    },
    mounted() {
      const _self = this
      $(this.$refs.modal).on('hidden.bs.modal', function() {
          _self.$emit('hidden')
      })

      if (this.values && this.values.length > 0) {
          $(this.$refs.modal).modal('show')
      }
    },
    methods: {
      chooseAgency(companyId: string) {
          this.$emit('submit', companyId)
          $(this.$refs.modal).modal('hide');
      }
    }
})
